module.exports = __webpack_public_path__ + "static/media/SearchPageIcon.826ea187.svg";